<div align="end">
  <i (click)="closeDialog()" class="material-icons clear-icon">clear</i>
</div>
<div class="content-center">
  <div class="qr-content">
    <div class="model">
      <img [src]="qrCodeUrl" alt="QR Code" class="qr-code-image" *ngIf="qrCodeUrl && qrCodeUrl !== ''">
    </div>
    <div *ngIf="data.menuName">
      <p class="qr-content info">{{ data.menuName }}</p>
      <span class="mb-1 font" *ngIf="data.address">{{ data.address }}</span>
    </div>
    <div class="button">
      <div class="modal-footer">
        <button class="btn download" (click)="copyLink()">
          <span>{{ 'qr_modal.copy_card_link' | translate }}</span>
        </button>
        <button class="btn download" (click)="saveImage()">
          <span>{{ 'qr_modal.download_qr' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
